var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FileThumbnails",class:{ 'FileThumbnails--wide': _vm.wide }},_vm._l((_vm.files),function(file){return _c('FileThumnail',{key:`file-${file.uuid}`,attrs:{"uuid":file.uuid,"disabled":_vm.disabled,"linklabel":_vm.linklabel,"filenameprefix":_vm.filenameprefix},on:{"disconnect":_vm.handleDisconnectFile}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }